/* eslint-disable */

export const states = [
  {
    name: "أدرار",
    hide: true,
    price: "500",
    wilaya_code: "01",
  },
  {
    price: "500",
    hide: true,
    wilaya_code: "02",
    name: "الشلف",
  },
  {
    wilaya_code: "03",
    price: 500,
    hide: true,
    name: "الأغواط",
  },
  {
    price: 600,
    hide: true,
    wilaya_code: "04",
    name: "أم البواقي",
  },
  {
    price: 5,
    name: "باتنة",
    hide: true,
    wilaya_code: "05",
  },
  {
    wilaya_code: "06",
    hide: true,
    price: 100,
    name: "بجاية",
  },
  {
    wilaya_code: "07",
    name: "بسكرة",
    hide: true,
    price: "300",
  },
  {
    hide: true,
    wilaya_code: "09",
    price: 0,
    name: "البليدة",
  },
  {
    name: "بشار",
    hide: true,
    wilaya_code: "08",
    price: 100,
  },
  {
    name: "البويرة",
    price: 100,
    wilaya_code: "10",
    hide: true,
  },
  {
    wilaya_code: "11",
    price: 100,
    hide: true,
    name: "تمنراست",
  },
  {
    name: "تبسة",
    wilaya_code: "12",
    price: 100,
    hide: true,
  },
  {
    wilaya_code: "13",
    price: 100,
    hide: true,
    name: "تلمسان",
  },
  {
    name: "تيارت",
    price: 100,
    wilaya_code: "14",
    hide: true,
  },
  {
    hide: true,
    name: "تيزي وزو",
    price: 100,
    wilaya_code: "15",
  },
  {
    wilaya_code: "16",
    price: 100,
    hide: true,
    name: "الجزائر",
  },
  {
    wilaya_code: "17",
    hide: true,
    price: 100,
    name: "الجلفة",
  },
  {
    hide: true,
    wilaya_code: "18",
    price: 100,
    name: "جيجل",
  },
  {
    price: 100,
    name: "سطيف",
    hide: true,
    wilaya_code: "19",
  },
  {
    name: "سعيدة",
    price: 100,
    wilaya_code: "20",
    hide: true,
  },
  {
    price: 100,
    name: "سكيكدة",
    wilaya_code: "21",
    hide: true,
  },
  {
    hide: true,
    name: "سيدي بلعباس",
    price: 100,
    wilaya_code: "22",
  },
  {
    hide: true,
    name: "عنابة",
    wilaya_code: "23",
    price: 100,
  },
  {
    price: 100,
    hide: true,
    wilaya_code: "24",
    name: "قالمة",
  },
  {
    price: 100,
    name: "قسنطينة",
    hide: true,
    wilaya_code: "25",
  },
  {
    name: "المدية",
    price: 100,
    wilaya_code: "26",
    hide: true,
  },
  {
    hide: true,
    name: "مستغانم",
    wilaya_code: "27",
    price: 100,
  },
  {
    wilaya_code: "28",
    price: 100,
    name: "المسيلة",
    hide: true,
  },
  {
    price: 100,
    wilaya_code: "29",
    name: "معسكر",
    hide: true,
  },
  {
    name: "ورقلة",
    hide: true,
    price: 100,
    wilaya_code: "30",
  },
  {
    hide: true,
    name: "وهران",
    wilaya_code: "31",
    price: 100,
  },
  {
    hide: true,
    name: "البيض",
    price: 100,
    wilaya_code: "32",
  },
  {
    hide: true,
    name: "إليزي",
    wilaya_code: "33",
    price: 100,
  },
  {
    name: "برج بوعريريج",
    hide: true,
    price: 100,
    wilaya_code: "34",
  },
  {
    name: "بومرداس",
    wilaya_code: "35",
    hide: true,
    price: 100,
  },
  {
    name: "الطارف",
    price: 100,
    hide: true,
    wilaya_code: "36",
  },
  {
    wilaya_code: "37",
    price: 100,
    hide: true,
    name: "تندوف",
  },
  {
    wilaya_code: "38",
    name: "تيسمسيلت",
    hide: true,
    price: 100,
  },
  {
    wilaya_code: "39",
    name: "الوادي",
    price: 100,
    hide: true,
  },
  {
    name: "خنشلة",
    wilaya_code: "40",
    hide: true,
    price: 100,
  },
  {
    hide: true,
    price: 100,
    name: "سوق أهراس",
    wilaya_code: "41",
  },
  {
    hide: true,
    price: 100,
    name: "تيبازة",
    wilaya_code: "42",
  },
  {
    name: "ميلة",
    price: 100,
    wilaya_code: "43",
    hide: true,
  },
  {
    name: "عين الدفلى",
    wilaya_code: "44",
    price: 100,
    hide: true,
  },
  {
    hide: true,
    wilaya_code: "45",
    price: 100,
    name: "النعامة",
  },
  {
    name: "عين تيموشنت",
    price: 100,
    wilaya_code: "46",
    hide: true,
  },
  {
    name: "غرداية",
    hide: true,
    price: 100,
    wilaya_code: "47",
  },
  {
    hide: true,
    name: "غليزان",
    wilaya_code: "48",
    price: 100,
  },
  {
    hide: true,
    price: 100,
    wilaya_code: "49",
    name: "تيميمون",
  },
  {
    name: "برج باجي مختار",
    wilaya_code: "50",
    price: 100,
    hide: true,
  },
  {
    price: 100,
    name: "أولاد جلال",
    wilaya_code: "51",
    hide: true,
  },
  {
    hide: true,
    wilaya_code: "52",
    price: 100,
    name: "بني عباس",
  },
  {
    name: "عين صالح",
    price: 100,
    wilaya_code: "53",
    hide: true,
  },
  {
    price: 100,
    name: "عين قزام",
    hide: true,
    wilaya_code: "54",
  },
  {
    wilaya_code: "55",
    price: 100,
    hide: true,
    name: "تقرت",
  },
  {
    name: "جانت",
    price: 100,
    wilaya_code: "56",
    hide: true,
  },
  {
    name: "المغير",
    price: 100,
    wilaya_code: "57",
    hide: true,
  },
  {
    price: 100,
    name: "المنيعة",
    wilaya_code: "58",
    hide: true,
  },
];
